import Vuex from 'vuex';
import Vue from 'vue';
import axios from 'axios';

Vue.use(Vuex);

export default {
    namespaced: true,
    state: {
        states: {},
        dealerships: {},
        brands: {},
        models: {},
        years: {},
        filters: {},
        price: 0,
        statesAll: [],
        productType: {},
        priceFilterSelected: 0,
        kilometerFilterSelected: 0,
        priceRange: [
            {
                value:1,
                name: 'Hasta $450,000'
            },
            {
                value:2,
                name: 'Entre $450,000 y $650,000'
            },
            {
                value:3,
                name: 'Entre $650,000 y $850,000'
            },
            {
                value:4,
                name: 'Más de $850,000'
            }
        ],
        kilometersRange: [
            {
                value:1,
                name: '0 km 20,000 km'
            },
            {
                value:2,
                name: '20,001 a 40,000 km'
            },
            {
                value:3,
                name: '40,001 a 70,000 km'
            },
            {
                value:4,
                name: '70,001 a 100,000 km'
            },
            {
                value:5,
                name: '100,001 km o más'
            }
        ]
    },
    actions: {

        async getStates({ commit }) {
            let { data } = await axios.get('/nuevos/filtros/dealerships-states');
            const sortData = _.sortBy(data, 'name');
            sessionStorage.setItem('states', JSON.stringify(sortData));
            this.dispatch('catalogNewVehicle/getDealershipsStates')
            commit('setStates', sessionStorage.getItem('states'));
        },

        async getDealershipsStates({ commit }) {
            let { data } = await axios.get('/nuevos/filtros/dealerships-states');
            const sortData = _.sortBy(data, 'name');
            sessionStorage.setItem('dealerships_states', JSON.stringify(data));
            this.dispatch('catalogNewVehicle/getStatesDealerships')
            commit('setStates', sessionStorage.getItem('dealerships_states'));
        },

        async getStatesDealerships({ commit }) {
            let { data } = await axios.get('/nuevos/filtros/states-dealerships');
            const sortData = _.sortBy(data, 'name');
            sessionStorage.setItem('dealerships', JSON.stringify(sortData));
            commit('setDealerships', sessionStorage.getItem('dealerships'));
        },

        async getBrands({ commit }) {
            let { data } = await axios.get('/nuevos/all-brands-vehicles');
            const sortData = _.sortBy(data, 'title');
            sessionStorage.setItem('brands', JSON.stringify(sortData));
            commit('setBrands', sessionStorage.getItem('brands'));
        },

        async getModels({ commit }, payload) {
            if (!sessionStorage.getItem('newbrandsIds')) {

                let { data } = await axios.get(`/nuevos/all-models-vehicles`);
                const sortData = _.sortBy(data, 'title');
                sessionStorage.setItem('models', JSON.stringify(sortData));
                commit('setModels', sessionStorage.getItem('models'));
            }
        },

        async getYears({ commit }) {
            if (!sessionStorage.getItem('years')) {
                let { data } = await axios.get('/client/years');
                sessionStorage.setItem('years', JSON.stringify(data));
            }
            commit('setYears', sessionStorage.getItem('years'));
        },

        async getPrice({ commit }) {
            if (!sessionStorage.getItem('price')) {
                let { data } = await axios.get('/client/products/max/price');
                sessionStorage.setItem('price', data);
            }
            commit('setPrice', sessionStorage.getItem('price'));
        },

        async getFiltersByUrl({ commit }) {
            var urlParams = new URLSearchParams(window.location.search);
            var queryLocation = {};

            queryLocation.prices = {
                from: 0,
                to: this.state.catalogNewVehicle.price
            };

            queryLocation.plus = {
                one_owner: false,
                invoice: false,
                user_verify: false,
            };
            queryLocation.states = urlParams.has('states') ? urlParams.get('states').split(',').filter(item => !!item && item != 'undefined') : [];
            queryLocation.dealerships = urlParams.has('dealerships') ? urlParams.get('dealerships').split(',').filter(item => !!item && item != 'undefined') : [];
            queryLocation.page = urlParams.has('page') ? urlParams.get('page') : 1;
            queryLocation.models = urlParams.has('models') ? urlParams.get('models').split(',').filter(item => !!item && item != 'undefined') : [];
            queryLocation.brands = urlParams.has('brands') ? urlParams.get('brands').split(',').filter(item => !!item && item != 'undefined') : [];
            queryLocation.orderby = urlParams.has('orderby') ? urlParams.get('orderby') : 1;
            queryLocation.search = urlParams.has('search') ? urlParams.get('search') : '';
            queryLocation.search_word = urlParams.has('search_word') ? urlParams.get('search_word') : '';
            queryLocation.types_car = urlParams.has('types_car') ? urlParams.get('types_car').split(',').filter(item => !!item && item != 'undefined') : [];
            queryLocation.years = urlParams.has('years') ? urlParams.get('years').split(',').filter(item => !!item && item != 'undefined') : [];

            /* if (urlParams.has('years')) {
                var years = urlParams.get('years').split(',');
                if (!!years[0]) {
                    queryLocation.years.from = years[0].replace('from:', '');
                }
                if (!!years[1]) {
                    queryLocation.years.to = years[1].replace('to:', '');
                }
            }
            if (urlParams.has('prices')) {
                var prices = urlParams.get('prices').split(',');
                if (!!prices[0]) {
                    queryLocation.prices.from = prices[0].replace('from:', '');
                }
                if (!!prices[1]) {
                    queryLocation.prices.to = prices[1].replace('to:', '');
                }
            } */

            commit('setFilters', queryLocation);
        },
        async getAllStates({ commit }) {
            let { data } = await axios.get('/client/states/all');
            commit('setAllStates', data);
        },
        async getProductTypes({ commit }) {
            let { data } = await axios.get('/client/types/new-vehicles');
            sessionStorage.setItem('types_car', JSON.stringify(data));
            commit('setProductTypes', sessionStorage.getItem('types_car'));
        },
        setPriceFilterSelected({ commit }, payload) {
            commit('setPriceSelected', payload)
        },
        setKilometerFilterSelected({ commit }, payload) {
            commit('setKilometerSelected', payload)
        },
        updateModelsFilter({ commit }, brands) {
            commit('setModelSelected', brands)
        }
    },
    mutations: {
        setStates(state, data) {
            state.states = JSON.parse(data);
        },
        setDealerships(state, data) {
            state.dealerships = JSON.parse(data);
        },
        setBrands(state, data) {
            state.brands = JSON.parse(data);
        },
        setModels(state, data) {
            state.models = JSON.parse(data);
        },
        setYears(state, data) {
            state.years = JSON.parse(data);
        },
        setFilters(state, data) {
            state.filters = data;
        },
        setPrice(state, data) {
            state.price = data;
        },
        setAllStates(state, data) {
            state.statesAll = data;
        },
        setProductTypes(state, data) {
            state.productType = JSON.parse(data);
        },
        setPriceSelected(state, payload) {
            state.priceFilterSelected = payload;
        },
        setKilometerSelected(state, payload) {
            state.kilometerFilterSelected = payload;
        },
        setModelSelected(state, brands) {
            if (brands.length > 0) {
                const brandsIds = brands.map(item => parseInt(item));
                sessionStorage.setItem('newbrandsIds', JSON.stringify(brandsIds));
                state.models = _.filter(JSON.parse(sessionStorage.getItem('models')), function(item, key) {
                        return _.includes(brandsIds, item.brand_id);
                    });
            } else {
                sessionStorage.removeItem('newbrandsIds');
                state.models = JSON.parse(sessionStorage.getItem('models'));
            }
        }
    }
}
